import { render, staticRenderFns } from "./FooterPzId.vue?vue&type=template&id=8b820bf6&scoped=true&"
import script from "./FooterPzId.vue?vue&type=script&lang=js&"
export * from "./FooterPzId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b820bf6",
  null
  
)

export default component.exports